module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.model,
      "label-width": "200px"
    }
  }, [_c('el-tabs', _vm._l((_vm.config.formFields), function(tab) {
    return _c('el-tab-pane', {
      key: tab.label,
      attrs: {
        "label": tab.label
      }
    }, [_vm._l((tab.body), function(item) {
      return _c(item.component, {
        key: item._uid,
        tag: "div",
        attrs: {
          "model": _vm.model,
          "root-config": _vm.rootConfig,
          "options": item.options
        }
      })
    }), _vm._v(" "), _vm._l((tab.fields), function(field) {
      return (_vm.isVisibleInCurrentShop(field)) ? _c('el-form-item', {
        key: field.name,
        class: {
          'form-field': _vm.isCustomerSupport()
        },
        attrs: {
          "label": field.label
        }
      }, [_c(field.component, {
        tag: "div",
        attrs: {
          "placeholder": field.placeholder,
          "root-config": _vm.rootConfig,
          "options": field.options,
          "type": field.type
        },
        on: {
          "input": function($event) {
            return _vm.setModel(field.name)
          }
        },
        model: {
          value: (_vm.model[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.model, field.name, $$v)
          },
          expression: "model[field.name]"
        }
      })], 1) : _vm._e()
    })], 2)
  }), 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Save")]), _vm._v(" "), (!_vm.isCustomerSupport()) ? _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'admin',
          params: {
            id: 'all',
            action: 'index'
          },
        })
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aaa428f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueCrudNew.vue
// module id = 520
// module chunks = 1